// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__feW9u","requiredAsterisk":"Info_requiredAsterisk__1e0Tf"};